<template>
    <div>
        <p class="loading text-center pt-5" v-if="loader.firstLoading">
            <i class="fas fa-spinner fa-spin" style="font-size:2rem"></i>
        </p>

        <div v-else>
            <div v-if="loader.rows.length">

                <base-table type="hover" :data="loader.rows">

                    <template slot="columns">
                        <th width="50px"></th>
                        <th>{{ $t('xapi.common.profile-id') }} / {{ $t('xapi.common.type') }}</th>
                        <th>{{ $t('xapi.common.agent-id') }}</th>
                    </template>

                    <template slot-scope="{row}">

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null" 
                            @click="open(row)" 
                            class="td-actions"
                        >
                            <div class="index text-warning">
                                {{ row.index }}
                            </div>
                        </td>

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null"
                            @click="open(row)"
                        >
                            {{ row.profile_id }}
                            <div><small>{{ row.profile_type }}</small></div>
                        </td>

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null"
                            @click="open(row)"
                        >
                            {{ row.agent.type }}
                            <div v-if="row.agent.part1"><small>{{ row.agent.part1 }}</small></div>
                            <div v-if="row.agent.part2"><small>{{ row.agent.part2 }}</small></div>
                        </td>

                    </template>

                </base-table>

                <div slot="footer" class="text-center mt-3" v-if="loader.hasMore()">
                    <base-button round type="primary" :loading="loader.nextLoading" @click="loader.nextLoad()">
                        {{ $t('common.load-more') }}
                    </base-button>
                </div>

            </div>
            
            <div v-else>
                <p class="text-center pt-3">{{ $t('xapi.common.search.no-result') }}</p>
            </div>

        </div>

        <portal to="modals">

            <modal class="fullscreen" :title="'#'+index" title-color="warning" v-model="modals.viewer">
                <json-viewer :data="selected"></json-viewer>
            </modal>

        </portal>
    </div>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'

    export default {

        data() {
            return {
                loader: this.$xapi.loaders.agentProfiles,
                filters: this.$xapi.filters.agentProfiles,
                modals: new ModalsController('viewer'),
                hovered: null,
                selected: null,
                index: null,
            }
        },

        created() {
            this.loader.setMapData(this.mapData)
            this.loader.firstLoad()
        },

        methods: {

            mapData(item, index) {
                return {
                    index: index + 1,
                    data: item.data.content,
                    profile_id: item.profile_id,
                    profile_type: item.data.type,
                    agent: this.agent(item),
                }
            },

            agent(item) {
                const xapiAgent = this.xapiAgent(item)
                let agent = {}
                if (xapiAgent.mbox) {
                    agent.type = 'mbox'
                    agent.part1 = String(xapiAgent.mbox).substr(7)
                } else if (xapiAgent.account) {
                    agent.type = 'account'
                    agent.part1 = xapiAgent.account.name
                    agent.part2 = xapiAgent.account.homePage
                } else if (xapiAgent.openid) {
                    agent.type = 'openid'
                    agent.part1 = xapiAgent.openid
                } else {
                    agent.type = 'mbox_sha1sum'
                }
                return agent
            },

            xapiAgent(item) {
                let parts = item.vid.split('::')
                let agent = {
                    objectType: item.is_group ? 'Group' : 'Agent',
                }
                if (item.name) {
                    agent.name = item.name
                }
                if (parts[0] == 'account') {
                    let accountParts = parts[1].split('@')
                    agent[parts[0]] = {
                        name: accountParts[0],
                        homePage: accountParts[1]
                    }
                } else {
                    agent[parts[0]] = parts[1]
                }
                return agent
            },

            open(row) {
                if (row.profile_type == 'application/json') {
                    this.selected= row.data
                    this.index = row.index
                    this.modals.open('viewer')
                }
            }
        }
    }
</script>

<style scoped>

    td:hover {
        cursor: pointer;
    }
    td .index {
        width: 30px;
        height: 30px;
        text-align: center;
        padding-top: 5px;
    }

</style>